import axios from 'axios';
import { baseApi, token } from '../../../services/Apis';

export const restaurantZonesApi = `${baseApi}/restaurant-zones`;

export const getAllZonasRestauranteService = async (params) => {
  // params.active = true;
  const res = await axios.get(restaurantZonesApi, {
    headers: await token({}),
    params,
  });
  return res;
};

export const saveZonasRestauranteService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.put(`${restaurantZonesApi}/${id}`, data, {
      headers: await token({}),
    });
  } else {
    res = await axios.post(`${restaurantZonesApi}`, data, {
      headers: await token({}),
    });
  }
  return res.data;
};

export const getOneZonasRestauranteService = async (id) => {
  const res = await axios.get(`${restaurantZonesApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};

export const deleteZonasRestauranteService = async (id) => {
  const res = await axios.delete(`${restaurantZonesApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};
